<template>
  <div>
    <div class="verify">
      <div class="logo"></div>
      <div class="form">
        <form v-if="!loading && set_password" @submit.prevent="onLogin">
          <h5 class="text-center">Set a new password</h5>

          <input
            @change="reset"
            type="password"
            required
            placeholder="Email"
            v-model="user.newPassword"
          />
          <input
            required
            type="password"
            @change="reset"
            placeholder="Password"
            v-model="user.confirmPassword"
          />

          <button
            :disabled="loading_password"
            class="btn auth-btn"
            @click="onLogin"
          >
            <span
              v-show="loading_password"
              class="spinner-border spinner-border-sm"
            ></span>
            <span v-show="!loading_password">Set Password</span>
          </button>
        </form>
        <b-spinner v-show="loading" variant="primary"></b-spinner>

        <p v-show="error" class="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import ikebana from "../../services/ikebana";
export default {
  props: {
    id: String,
    code: String,
  },
  data() {
    return {
      loading: false,
      loading_password: false,
      set_password: false,
      error: "",
      user: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    setPassword() {
      this.loading_password = true;
      ikebana.changePassword(this.user).then(
        (response) => {
          this.$store.dispatch("SET_USER", response.data);
          this.loading_password = false;
        },
        (error) => {
          this.error = error.response.data.Message;
          this.loading = false;
        }
      );
    },
  },
  created: function () {
    var params = this.$route.query;
    this.loading = true;
    ikebana.verify(params.id, params.code).then(
      (response) => {
        this.set_password = true;
        this.loading = false;
        this.$router.push("/auth/reset?" + response.data);
      },
      (error) => {
        this.error = error.response.data.Message;
        this.loading = false;
      }
    );
  },
};
</script>
<style lang="css">
.verify {
  background: white;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  align-content: center;
  justify-content: center;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 20px 50px 20px 50px;
}

.error-container {
  height: 100px;
  min-height: 100px;
}
.error {
  color: red;
  text-align: center;
  margin-top: 50px;
}
@media (max-width: 768px) {
  .forgot {
    width: 100% !important;
    height: 60vh !important;
  }
}
.auth-btn {
  border-radius: 12px;
  background: #ad1f23;
}
a {
  text-decoration: none;
  text-align: center;
  color: #707070;
}

.verify input {
  margin-bottom: 10px;
}

input {
  width: 100%;
  height: 50px;
}

.logo {
  height: 100px;
  width: 100%;
  padding: 0;
  margin: 0;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center center;
  background: url("../../assets/logo.png") center center no-repeat;
}
</style>
